var map = {
	"./2023/autumn/poster/team_honor_yajun.png": "2f13",
	"./2024/winter/poster/team_honor_yajun.png": "a971",
	"./2025/spring/poster/team_honor_yajun.png": "121c",
	"./2025/summer/poster/team_honor_yajun.png": "9b89",
	"./2025/winter/poster/team_honor_yajun.png": "a6f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "478b";